(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-opening-cart-form], .enriq-cart__form').forEach(form => {
      if (form.dataset.openingInitialized) return;
      form.dataset.openingInitialized = 'true';
      let timer;
      form.addEventListener('change', event => {
        if (!event.target.matches('input[name="updates[]"]')) return;
        clearTimeout(timer);
        const input = event.target;
        const quantity = Number(input.value);
        if (!Number.isInteger(quantity) || quantity < 0 || !input.checkValidity()) return;
        timer = setTimeout(() => {
          if (input.isConnected) form.requestSubmit(form.querySelector('button[name="update"]'));
        }, 650);
      });
      form.addEventListener('submit', () => clearTimeout(timer));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
})();
